// extracted by mini-css-extract-plugin
export default {"card":"Guide_card__Q2+3y","header":"Guide_header__w3-MI","main":"Guide_main__uUXNy","icons":"Guide_icons__o253s","htmlCode":"Guide_htmlCode__g5k9w"};